/* ============================================================
   [CLAUDE 2026-08-07] Thumbnail strip scrolling - replacement
   ------------------------------------------------------------
   MEASURED BUG (product with 10 images, desktop, layout 1):

     .product-gallery__thumbnail_slider .slick-list
         clientHeight  694
         scrollHeight 1091          <- 4 thumbs clipped
         overflow-y   hidden
     .slick-track transform -> matrix(1,0,0,1,0,0)   ALWAYS

   The track transform never changes. Verified by clicking the
   theme's down arrow 6x and its up arrow 6x and logging the
   computed transform after each: translateY stayed 0 for every
   single click while slick's internal currentSlide walked
   0..9 and back. Selecting thumbnail 9 directly also left the
   strip parked at the top - slick writes that transform inline
   and synchronously, so this is not an animation artifact.

   Net effect on a 10-image product: thumbnails 7-10 are clipped
   and CANNOT be reached from the strip at all, and the arrows
   only shuffle an invisible pointer - which is why it felt like
   "you have to click a few times before it starts to move."

   Cause is slick's vertical math: slideHeight is measured at
   init, before the lazy-loaded thumbs have dimensions, so every
   setPosition() computes -currentSlide * 0 = 0.

   FIX: stop using slick's transform for this strip. This script
   adds the class claude-thumb-nav-on to the thumbnail container,
   which is what activates the CSS in claude-gallery-arrows.css
   that pins .slick-track to transform:none, turns .slick-list
   into a real scroll container, and hides the theme's two broken
   arrows. It then adds its own up/down buttons - one pinned to
   the top of the strip, one to the bottom - that scroll the list
   by exactly one thumbnail per click, and keeps the selected
   thumbnail scrolled into view when the main image changes,
   which the theme never did.

   FAIL-SAFE BY CONSTRUCTION: every CSS change is gated behind
   the class this script adds. If the script does not run, throws,
   or never finds a slider, the strip keeps the theme's original
   behaviour exactly. Nothing is changed until the replacement is
   actually in place.

   Deliberately NO jQuery: this site loads two jQuery copies
   asynchronously, so slick events fire on whichever instance won
   the race and delegation is unreliable. Everything here is
   native DOM + MutationObserver.

   Clicking a thumbnail still goes through slick's own handler -
   untouched. This only replaces the strip's scrolling.

   TO REVERT: delete the <script> tag for this file from
   snippets/layout-get-includes-end.liquid. The CSS then never
   activates.
   ============================================================ */
(function () {
  'use strict';
  try {
    var SLIDER = '.product-gallery__thumbnail_slider';
    var NAV = 'claude-thumb-nav';
    var ON = 'claude-thumb-nav-on';
    var READY = 'claude-thumb-ready';

    function chevron(dir) {
      return '<svg viewBox="0 0 24 14" width="15" height="9" aria-hidden="true" focusable="false"' +
        ' style="display:block;transform:rotate(' + (dir === 'up' ? 180 : 0) + 'deg)">' +
        '<path d="M1.7 1.6 12 11.1 22.3 1.6" fill="none" stroke="#354E57" stroke-width="2.6"' +
        ' stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }

    function makeBtn(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = NAV + ' ' + NAV + '--' + dir;
      b.setAttribute('aria-label', dir === 'up' ? 'Previous thumbnails' : 'More thumbnails');
      b.innerHTML = chevron(dir);
      return b;
    }

    /* distance between two consecutive thumbs, including the gap */
    function step(list) {
      var s = list.querySelectorAll('.slick-slide');
      if (s.length > 1) {
        var d = Math.round(s[1].getBoundingClientRect().top - s[0].getBoundingClientRect().top);
        if (d > 4) return d;
      }
      if (s.length) {
        var h = Math.round(s[0].getBoundingClientRect().height);
        if (h > 4) return h;
      }
      return 90;
    }

    /* Move the strip, with the end state guaranteed.

       Both scrollBy({behavior:'smooth'}) and a requestAnimationFrame tween are
       frozen when the page is not visible - measured in a minimised window:
       document.visibilityState 'hidden', 0 rAF frames in 500ms, and scrollTop
       still 0 after 13 arrow clicks, while a plain scrollTop assignment landed
       and held. A user with the window in front would not hit that, but an
       animation is not allowed to be the only thing that moves the strip.

       So: animate only when the page is actually visible, fall back to an
       instant jump when it is not, and in every case land on the exact target
       via a timer in case frames stop mid-tween. A click always moves. */
    function nudge(list, delta) {
      if (!delta) return;
      var start = list.scrollTop;
      var max = list.scrollHeight - list.clientHeight;
      var target = Math.max(0, Math.min(max, start + delta));
      if (Math.abs(target - start) < 1) return;

      var token = (list.__claudeScrollToken || 0) + 1;
      list.__claudeScrollToken = token;

      var visible = (document.visibilityState || 'visible') === 'visible';
      if (!window.requestAnimationFrame || !visible) {
        list.scrollTop = target;
        return;
      }

      var t0 = null;
      var DUR = 260;
      requestAnimationFrame(function frame(ts) {
        if (list.__claudeScrollToken !== token) return;   /* superseded */
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / DUR);
        var e = p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p;   /* easeInOutQuad */
        list.scrollTop = start + (target - start) * e;
        if (p < 1) requestAnimationFrame(frame);
      });

      /* safety net: if frames never arrive, still end up where we promised */
      setTimeout(function () {
        if (list.__claudeScrollToken === token) list.scrollTop = target;
      }, DUR + 140);
    }

    /* Pin the buttons to the top and bottom of the SCROLL VIEWPORT, not of
       the slider element. .product-gallery__thumbnail_slider carries h-100 and
       measured ~48px taller than its own .slick-list, so a plain CSS
       bottom:4px left the down button floating below the strip (measured:
       list bottom 907, button top 955). Both the list and the buttons share
       the slider as offset parent, so offsetTop/offsetHeight line them up
       exactly. Re-run on every sync so it survives resize and lazy loading. */
    function place(ui) {
      var l = ui.list;
      var h = ui.up.offsetHeight || 34;
      ui.up.style.bottom = 'auto';
      ui.down.style.bottom = 'auto';
      ui.up.style.top = (l.offsetTop + 4) + 'px';
      ui.down.style.top = (l.offsetTop + l.offsetHeight - h - 4) + 'px';
    }

    /* show the buttons only when the strip actually overflows, and fade
       whichever end we have reached. Never pointer-events:none - a control
       that looks present but swallows clicks is worse than one that
       visibly does nothing. */
    function sync(ui) {
      var l = ui.list;
      var over = (l.scrollHeight - l.clientHeight) > 4;
      ui.up.style.display = over ? '' : 'none';
      ui.down.style.display = over ? '' : 'none';
      if (!over) return;
      place(ui);
      ui.up.classList.toggle('is-end', l.scrollTop <= 2);
      ui.down.classList.toggle('is-end', l.scrollTop >= (l.scrollHeight - l.clientHeight - 2));
    }

    /* keep the selected thumbnail visible when the main image changes */
    function reveal(ui) {
      var active = ui.list.querySelector('.slick-current');
      if (!active) return;
      var lr = ui.list.getBoundingClientRect();
      var ar = active.getBoundingClientRect();
      if (ar.top < lr.top + 2) nudge(ui.list, ar.top - lr.top - 8);
      else if (ar.bottom > lr.bottom - 2) nudge(ui.list, ar.bottom - lr.bottom + 8);
    }

    function attach(slider) {
      if (!slider || slider.classList.contains(READY)) return true;
      var list = slider.querySelector('.slick-list');
      if (!list) return false;
      if (list.querySelectorAll('.slick-slide').length < 2) return false;

      slider.classList.add(READY);
      var box = slider.parentElement;
      if (box) box.classList.add(ON);           /* <- this activates the CSS */

      var ui = { list: list, up: makeBtn('up'), down: makeBtn('down') };
      slider.appendChild(ui.up);
      slider.appendChild(ui.down);

      /* sync() is also called straight after each click, not only from the
         scroll listener: scroll events are not dispatched while the page is
         hidden, which left the end-of-strip fade stale even though the strip
         had moved. Calling it directly makes the state update deterministic. */
      var press = function (dir) {
        return function (e) {
          e.preventDefault();
          e.stopPropagation();
          nudge(list, dir * step(list));
          sync(ui);
          setTimeout(function () { sync(ui); }, 420);
        };
      };
      ui.up.addEventListener('click', press(-1));
      ui.down.addEventListener('click', press(1));

      list.addEventListener('scroll', function () { sync(ui); }, { passive: true });
      window.addEventListener('resize', function () { sync(ui); });

      /* slick toggles .slick-current when the main image changes */
      try {
        new MutationObserver(function () { reveal(ui); sync(ui); })
          .observe(list, { attributes: true, attributeFilter: ['class'], subtree: true });
      } catch (e) { /* observer unsupported: buttons still work */ }

      /* thumbs are lazy-loaded, so keep re-measuring for a while */
      var n = 0;
      var t = setInterval(function () {
        sync(ui);
        if (++n > 20) clearInterval(t);
      }, 500);

      sync(ui);
      return true;
    }

    function sweep() {
      var found = false;
      var all = document.querySelectorAll(SLIDER);
      for (var i = 0; i < all.length; i++) {
        if (attach(all[i])) found = true;
      }
      return found;
    }

    function boot() {
      sweep();
      /* slick initialises late and quick-view injects a gallery after
         load, so keep watching instead of giving up after one pass */
      var tries = 0;
      var poll = setInterval(function () {
        sweep();
        if (++tries > 40) clearInterval(poll);
      }, 250);
      try {
        new MutationObserver(function () { sweep(); })
          .observe(document.body, { childList: true, subtree: true });
      } catch (e) { /* poll alone still covers the normal page */ }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  } catch (e) { /* never break the page */ }
})();
